import PlacePicker from '../PlacePicker'
import Field, { inputClass } from '../../common/Field'
import { useWizard } from '../../../context/WizardContext'
import { FIELDS } from '../../../utils/copy'

/**
 * Step 2 — where the rider goes first.
 *
 * Two answers on one screen, which breaks the one-question rule, and does so because they
 * are one question. The pin tells the rider where to ride; `pickupSource` is what they ask
 * for when they arrive, and an order carrying only one of them strands them either on the
 * wrong street or in the right building with nothing to say.
 *
 * Choosing a search result fills both at once — the pin from the place, the name from what
 * the customer just tapped — so the second box is confirmed rather than typed.
 */
export default function PickupStep() {
  const { state, errors, setField, setLocation } = useWizard()

  return (
    <div className="grid gap-4">
      <PlacePicker
        kind="pickup"
        loc={state.pickup}
        setLoc={(next) => setLocation('pickup', next)}
        error={Boolean(errors.pickup)}
        errorMessage={errors.pickup}
        onPickName={(name) => setField('pickupSource', name)}
      />

      <Field id="pickupSource" label={FIELDS.pickupSource} error={errors.pickupSource} required>
        <input
          id="pickupSource"
          type="text"
          maxLength={200}
          value={state.pickupSource}
          onChange={(event) => setField('pickupSource', event.target.value)}
          aria-invalid={Boolean(errors.pickupSource)}
          aria-describedby={errors.pickupSource ? 'pickupSource-error' : undefined}
          className={inputClass(errors.pickupSource)}
        />
      </Field>
    </div>
  )
}
